'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressiveImageFACC = require('./ProgressiveImageFACC');

var _ProgressiveImageFACC2 = _interopRequireDefault(_ProgressiveImageFACC);

var _BackgroundImage = require('../BackgroundImage');

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

require('./ProgressiveBackgroundImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Shows an image which progressively becomes better quality by first showing a thumbnail of the image,
 * and then, once the larger version has loaded, replaces the thumbnail with the full size image.
 *
 * NOTE: The component initially shows the source file because it would otherwise cause a flash of content when dragging
 * an element that has already loaded.
 * Now there will be a slight flash when the image has not yet loaded, but that's an acceptable trade off.
 */
// Lib
var ProgressiveBackgroundImage = function ProgressiveBackgroundImage(props) {
    var thumbnail = props.thumbnail;


    return _react2.default.createElement(
        _ProgressiveImageFACC2.default,
        props,
        function (_ref) {
            var hideImage = _ref.hideImage,
                visibleSource = _ref.visibleSource;
            return _react2.default.createElement(
                _BackgroundImage2.default,
                { className: 'ProgressiveBackgroundImage', source: thumbnail },
                _react2.default.createElement(_BackgroundImage2.default, { className: (0, _classnames2.default)('image', { transparent: hideImage }),
                    source: visibleSource })
            );
        }
    );
};

// Styles


// Components


ProgressiveBackgroundImage.propTypes = {
    thumbnail: _propTypes2.default.string,
    hideImage: _propTypes2.default.bool,
    visibleSource: _propTypes2.default.string
};

exports.default = ProgressiveBackgroundImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/progressiveImages/ProgressiveBackgroundImage.js
// module id = 1902
// module chunks = 0